var extendFlags,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

extendFlags = function() {
  var bodyClasses, ref, ref1;
  bodyClasses = document.body.classList || $(document.body).getClasses();
  return _.extend(window.Groupon, {
    App: {
      name: $(document.head).attr('data-app')
    },
    Browsers: {
      chrome: !!window.chrome,
      ltIE10: $('html').hasClass('lt-ie10'),
      phantomJS: !!(window._phantom || window.callPhantom),
      safari: ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) > -1 && !((ref1 = navigator.userAgent) != null ? ref1.match('CriOS') : void 0)
    },
    PageFlags: {
      isWeb: indexOf.call(bodyClasses, 'is-web') >= 0,
      isTouch: indexOf.call(bodyClasses, 'is-touch') >= 0,
      isLegacyResponsive: indexOf.call(bodyClasses, 'ls-resp') >= 0,
      isTouchRedesign: indexOf.call(bodyClasses, 't-redesign') >= 0,
      isTouchRequest: indexOf.call(bodyClasses, 'is-touch-request') >= 0
    }
  });
};

module.exports = function() {
  if (document.body != null) {
    return extendFlags();
  } else {
    return $(function() {
      return extendFlags();
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9ncm91cG9uX2V4dGVuZGVkLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvZ3JvdXBvbl9leHRlbmRlZC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSxXQUFBO0VBQUE7O0FBQUEsV0FBQSxHQUFjLFNBQUE7QUFFWixNQUFBO0VBQUEsV0FBQSxHQUFjLFFBQVEsQ0FBQyxJQUFJLENBQUMsU0FBZCxJQUEyQixDQUFBLENBQUUsUUFBUSxDQUFDLElBQVgsQ0FBZ0IsQ0FBQyxVQUFqQixDQUFBO1NBRXpDLENBQUMsQ0FBQyxNQUFGLENBQVMsTUFBTSxDQUFDLE9BQWhCLEVBQXlCO0lBQ3ZCLEdBQUEsRUFDRTtNQUFBLElBQUEsRUFBTSxDQUFBLENBQUUsUUFBUSxDQUFDLElBQVgsQ0FBZ0IsQ0FBQyxJQUFqQixDQUFzQixVQUF0QixDQUFOO0tBRnFCO0lBR3ZCLFFBQUEsRUFDRTtNQUFBLE1BQUEsRUFBUSxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQWpCO01BQ0EsTUFBQSxFQUFRLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxRQUFWLENBQW1CLFNBQW5CLENBRFI7TUFFQSxTQUFBLEVBQVcsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLFFBQVAsSUFBbUIsTUFBTSxDQUFDLFdBQTNCLENBRmI7TUFHQSxNQUFBLHlDQUF3QixDQUFFLE9BQWxCLENBQTBCLE9BQTFCLFdBQUEsR0FBcUMsQ0FBQyxDQUF0QyxJQUE0Qyw2Q0FBdUIsQ0FBRSxLQUFyQixDQUEyQixPQUEzQixXQUh4RDtLQUpxQjtJQVF2QixTQUFBLEVBQ0U7TUFBQSxLQUFBLEVBQU8sYUFBWSxXQUFaLEVBQUEsUUFBQSxNQUFQO01BQ0EsT0FBQSxFQUFTLGFBQWMsV0FBZCxFQUFBLFVBQUEsTUFEVDtNQUVBLGtCQUFBLEVBQW9CLGFBQWEsV0FBYixFQUFBLFNBQUEsTUFGcEI7TUFHQSxlQUFBLEVBQWlCLGFBQWdCLFdBQWhCLEVBQUEsWUFBQSxNQUhqQjtNQUlBLGNBQUEsRUFBZ0IsYUFBc0IsV0FBdEIsRUFBQSxrQkFBQSxNQUpoQjtLQVRxQjtHQUF6QjtBQUpZOztBQW9CZCxNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFBO0VBQ2YsSUFBRyxxQkFBSDtXQUNFLFdBQUEsQ0FBQSxFQURGO0dBQUEsTUFBQTtXQUdFLENBQUEsQ0FBRSxTQUFBO2FBQUcsV0FBQSxDQUFBO0lBQUgsQ0FBRixFQUhGOztBQURlIn0=
